import { z } from 'zod';
import { METODOS_PAGO } from './reserva';
export const PagoSchema = z.object({
    id: z.string().uuid(),
    reservaId: z.string().uuid(),
    reservaCodigo: z.string().nullable().optional(),
    // 'WEB' si lo creo el sitio publico, 'GESTION' si fue cargado por staff.
    canal: z.enum(['WEB', 'GESTION']).optional(),
    pasarela: z
        .object({
        clave: z.string(),
        etiqueta: z.string(),
    })
        .nullable()
        .optional(),
    claseId: z.string().uuid().nullable().optional(),
    metodo: z.string(),
    monto: z.coerce.number(),
    pdvId: z.string().uuid().nullable(),
    usuarioId: z.string().uuid().nullable(),
    fecha: z.string(),
    estado: z.string(),
    reversaDe: z.string().uuid().nullable().optional(),
    motivoReverso: z.string().nullable().optional(),
    observaciones: z.string().nullable().optional(),
    proveedor: z.string().nullable().optional(),
    idExterno: z.string().nullable().optional(),
});
export const ImputacionClaseSchema = z.object({
    claseId: z.string().uuid(),
    inscripcionId: z.string().uuid(),
    fechaHoraInicio: z.string(),
    precio: z.coerce.number(),
    pagado: z.coerce.number(),
    saldo: z.coerce.number(),
    dictable: z.boolean(),
    minimoExigido: z.coerce.number(),
});
export const PagosDeReservaSchema = z.object({
    items: z.array(PagoSchema),
    totalPagado: z.coerce.number(),
    totalNeto: z.coerce.number(),
    paga: z.boolean(),
    imputacion: z.array(ImputacionClaseSchema).optional(),
});
export const RegistrarPagoSchema = z.object({
    metodo: z.enum(METODOS_PAGO),
    monto: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/, 'Monto inválido'),
    pdvId: z.string().uuid('Seleccioná el punto de venta'),
    observaciones: z.string().max(2000).optional().or(z.literal('')),
});
export const AplicacionDescuentoSchema = z.object({
    id: z.string().uuid(),
    reservaId: z.string().uuid(),
    reglaId: z.string().uuid().nullable().optional(),
    origen: z.string(),
    descripcion: z.string(),
    pct: z.union([z.string(), z.number()]).nullable().optional(),
    monto: z.union([z.string(), z.number()]).nullable().optional(),
    montoAplicado: z.coerce.number(),
    fecha: z.string(),
    activo: z.boolean(),
});
